// removed by extract-text-webpack-plugin
module.exports = {"container":"PromoCode__container__f55afa9"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Sidebar/styles/PromoCode.scss
// module id = 3476
// module chunks = 4